import { Exit } from "slotworks/state-machine/data/exit";
import State from "slotworks/state-machine/states/state";
abstract class SuperState extends State {

    public subState: State;

    /**
     * Call in order to repeat the sub state
     */
    public repeat() {
        this.stateMachine.changeState(Exit.Repeat, this);
    }

    /**
     * Call to exit the super state without following the exit path of the current sub state.
     * This is for when the super state itself decides to change state; the sub states are ignored
     */
    public collapse() {
        this.stateMachine.changeState(Exit.Collapse, this);
    }

    /**
     * When a sub state completes, the event is bubbled up through the super state, to the state machine
     * Super state can either allow the complete, call for a repeat, or even ignore the complete altogether
     * Useful for repeating sub states while some race handler is resolved in the super state, EG win cycle during rollup
     */
    public onSubStateComplete() {
        this.complete();
        // this.repeat();
    }

    /**
     * When a sub state errors, the event is bubbled up through the super state, to the state machine
     */
    public onSubStateError() {
        this.error();
    }

}

export default SuperState;
